import React from 'react';
export var LeaveFullscreen = function LeaveFullscreen(_a) {
  var className = _a.className;
  return React.createElement("svg", {
    className: className,
    width: "16",
    height: "16",
    viewBox: "0 0 48 48"
  }, React.createElement("g", null, React.createElement("polygon", {
    points: "17,0 17,17 0,17 0,10 10,10 10,0 \t"
  })), React.createElement("g", null, React.createElement("polygon", {
    points: "0,31 17,31 17,48 10,48 10,38 0,38 \t"
  })), React.createElement("g", null, React.createElement("polygon", {
    points: "31,0 31,17 48,17 48,10 38,10 38,0 \t"
  })), React.createElement("g", null, React.createElement("polygon", {
    points: "48,31 31,31 31,48 38,48 38,38 48,38 \t"
  })));
};